<template>
    <div v-for="(card, index) in cards" >
        <div v-if="(card.url_admin ==='' || $store.state.adminState)">
            <CardsContent :card="card" :index="index" :key="langKey"/>
        </div>
    </div>
</template>

<script>
import CardsContent from '@/components/CardsContent.vue';

export default {
    components: {
        CardsContent,
    },
    data(){
        return{
            cards: [],
            langstore: null,
        };
    },
    mounted() {
        // requête pour envoyer en props les infos des services (selon langues)
        this.getPrefs();
    },
    computed:{
        langKey(){
          return this.$store.state.langKey;
        },
    },
    watch: {
        // chaque fois que langStore change, la requête pour la langue des textes s'exécute.
        langKey() {
          this.getPrefs(); // recharge les cartes quand la langue change
        }
    },
    methods: {
      async getPrefs() {
        if (!this.$I18n) {
          console.warn("I18n non chargé");
          return;
        }

        const lang = this.$store.state.lang;
        const inputHash = this.$I18n()[lang]?.services || {};
        const services = {};

        Object.keys(inputHash)
          .sort((a, b) => inputHash[a].rank - inputHash[b].rank)
          .forEach(k => {
            services[k] = inputHash[k];
          });

        this.cards = services; // met à jour le v-for
      },
    },
};

</script>

<style lang="scss" >
@import "../style/style.module.scss";
@import "../style/typo.scss";

</style>
